module.exports = "<div id=\"loader-wrapper\" *ngIf=\"Loading\">\r\n    <div id=\"loader\"></div>\r\n    <h1 class=\"text-center margin-bottom-10\">{{LoadingText}}...</h1>\r\n    <div class=\"loader-section section-left\"></div>\r\n    <div class=\"loader-section section-right\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/busy-loader.component.html
// module id = 1084
// module chunks = 1